import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form'
import { Input } from '@progress/kendo-react-inputs'
import { Label, Error, Hint } from '@progress/kendo-react-labels'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'

const FormInput = (fieldRenderProps: FieldRenderProps) => {
  const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, required, ...others } = fieldRenderProps
  const showValidationMessage = touched && validationMessage
  const showHint = !showValidationMessage && hint
  const hintId = showHint ? `${id}_hint` : ''
  const errorId = showValidationMessage ? `${id}_error` : ''

  const [searched, setSearched] = useState<boolean>(false)

  const handleSearch = () => {
    setSearched(true)
    if (others.onSearch) {
      others.onSearch()
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  const handleClearSearch = () => {
    setSearched(false)
    fieldRenderProps.onChange({ value: '' })
    if (others.onSearch) {
      others.onSearch()
    }
  }

  useEffect(() => {
    if (fieldRenderProps.value)
      setSearched(true)
  }, [fieldRenderProps.value])

  return (
    <FieldWrapper>
      <Label editorId={id} editorValid={valid} editorDisabled={disabled} optional={optional}>
        {required &&
          <span className='text-danger'>*</span>
        }
        {label} &nbsp;
        {
          showValidationMessage &&
          <Error id={errorId}>{validationMessage}</Error>
        }
      </Label>

      <div className='input-group k-form-field-wrap d-inline-flex'>
        <Input
          className='form-control'
          valid={valid}
          type={type}
          id={id}
          disabled={disabled}
          ariaDescribedBy={`${hintId} ${errorId}`}
          onKeyDown={handleKeyDown}
          {...others}
        />

        <Button onClick={handleSearch}
          disabled={disabled || !fieldRenderProps.value || fieldRenderProps.value === ''}>
          <FontAwesomeIcon icon='search' />
        </Button>

        {
          searched &&
          <Button
            name='reset'
            title='Clear Search'
            type='reset'
            className='bg-white text-dark border-dark'
            onClick={handleClearSearch}>
            <FontAwesomeIcon icon='times' /></Button>
        }

        {
          showHint &&
          <Hint id={hintId}>{hint}</Hint>
        }
      </div>
    </FieldWrapper>
  )
}

export default FormInput